import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import MonthlyPDFViewer from '../components/MonthlyPDFViewer';

const Library = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <main id="main-content" className="bg-white">
      <Navbar />
      
      {/* Header Section */}
      <section className="pt-32 pb-24 bg-[#630503] relative overflow-hidden">
        <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-1/5 bg-gradient-to-b from-[#630503] to-white"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <div className="mb-16">
              <span className="inline-block bg-white/10 backdrop-blur-sm text-white px-6 py-3 text-sm font-medium uppercase tracking-[0.2em] mb-8 rounded-full">
                Learning Resources
              </span>
              <h1 className="text-4xl lg:text-5xl xl:text-6xl font-light text-white mb-8 leading-[1.1] max-w-4xl mx-auto">
                P.S. 11X <span className="font-bold">Library</span>
              </h1>
              <div className="w-24 h-px bg-white/40 mx-auto mb-8"></div>
              <p className="text-lg lg:text-xl leading-relaxed text-white/95 max-w-3xl mx-auto">
                Welcome to the P.S. 11X library! Our school is so lucky to have two library spaces, one in our main building and one in the satellite building.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Library Mission */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
              Our <span className="font-bold text-[#630503]">Mission</span>
            </h2>
            <div className="w-24 h-px bg-[#630503]/40 mx-auto mb-8"></div>
            <div className="max-w-4xl mx-auto">
              <p className="text-lg text-gray-600 leading-relaxed">
                Our Mission for the library is to foster a love of reading by creating a culture of passionate and avid readers. We aim to provide open and equal access to high quality print and digital material with a collection that reflects the diversity of our community. The library's goal is to collaborate with faculty to promote and support the school's curriculum.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Monthly Book & SEL Word PDF Viewer */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
              Featured <span className="font-bold text-[#630503]">Programs</span>
            </h2>
            <div className="w-24 h-px bg-[#630503]/40 mx-auto mb-8"></div>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed mb-12">
              Check out our current book of the month and our collaboration with the SEL team to provide book recommendations for the SEL word of the month.
            </p>
          </div>

          <div className="flex justify-center">
            <div className="w-full max-w-6xl">
              <MonthlyPDFViewer />
            </div>
          </div>
        </div>
      </section>

      {/* NYPL Partnership */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
                <span className="font-bold text-[#630503]">New York Public Library</span> Partnership
              </h2>
              <div className="w-24 h-px bg-[#630503]/40 mb-8"></div>
              <p className="text-lg text-gray-600 leading-relaxed mb-8">
                We support our local public library! Sign up for your free NYPL library card online via this link.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed mb-8">
                Use your NYPL library card to access Libby! Libby allows you to access the NYPL's digital collection of e-books and audiobooks. Use this link to sign up for Libby.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="https://www.nypl.org/help/library-card"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#630503] text-white hover:bg-[#4a0402] font-semibold px-6 py-3 text-sm transition-colors rounded-lg text-center"
                >
                  Get NYPL Library Card
                </a>
                <a 
                  href="https://www.overdrive.com/apps/libby"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="border border-[#630503] text-[#630503] hover:bg-[#630503] hover:text-white font-semibold px-6 py-3 text-sm transition-colors rounded-lg text-center"
                >
                  Sign Up for Libby
                </a>
              </div>
            </div>
            <div className="bg-gray-200 rounded-xl h-96 flex items-center justify-center overflow-hidden">
              <img 
                src="/assets/images/library/publiclibrary.png" 
                alt="New York Public Library"
                className="max-w-full max-h-full object-contain"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
              <div style={{display: 'none'}} className="text-center text-gray-600">
                <div className="text-6xl mb-4">🏛️</div>
                <p className="text-lg font-medium">NYPL Library</p>
                <p className="text-sm">Public Library Image</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SORA Digital Library */}
      <section className="py-20 bg-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
              <span className="font-bold text-[#630503]">SORA</span>
            </h2>
            <div className="w-24 h-px bg-[#630503]/40 mx-auto mb-8"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <p className="text-lg text-gray-600 leading-relaxed mb-6">
                The Citywide Digital Library (CDL) on Sora is a collection of ebooks, audiobooks, comics, and magazines available for all NYCPS students and teachers. There is content for all grade levels PreK – 12.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed mb-6">
                With specially curated collections for each grade level, hand-picked titles by school librarians, and a variety of formats to engage your students – the CDL is a valuable resource for all readers in New York City Public Schools.
              </p>
              <div className="bg-white/80 border border-amber-200 p-6 rounded-lg mb-6">
                <p className="text-lg font-medium text-gray-900 mb-2">Getting Started:</p>
                <p className="text-gray-700 mb-2">Search for our school Highbridge.</p>
                <p className="text-gray-700">Log into SORA with your NYC DOE credentials!</p>
              </div>
              <a 
                href="https://soraapp.com/welcome/login/310229"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#630503] text-white hover:bg-[#4a0402] font-semibold px-8 py-4 text-base transition-colors rounded-lg inline-block"
              >
                Access SORA
              </a>
            </div>
            <div className="bg-gray-200 rounded-xl h-96 flex items-center justify-center overflow-hidden">
              <img 
                src="/assets/images/library/sora.png" 
                alt="SORA Reading App"
                className="max-w-full max-h-full object-contain"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
              <div style={{display: 'none'}} className="text-center text-gray-600">
                <div className="text-6xl mb-4">📱</div>
                <p className="text-lg font-medium">SORA App</p>
                <p className="text-sm">SORA Interface Image</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Summer Reading & Back to School */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
              Resources & <span className="font-bold text-[#630503]">Information</span>
            </h2>
            <div className="w-24 h-px bg-[#630503]/40 mx-auto mb-8"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-12">
            {/* Summer Reading */}
            <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden">
              <div className="bg-amber-600 p-6">
                <h3 className="text-2xl font-semibold text-white mb-2">SUMMER READING!</h3>
              </div>
              <div className="p-8">
                <p className="text-gray-600 leading-relaxed mb-6">
                  View the attached PDF to learn all about how you can beat the summer slide by reading through SORA this summer
                </p>
                <a 
                  href="https://c0c6a4a9-a713-44ac-a7b5-37f2d4a6d96d.filesusr.com/ugd/181d6e_211332b698ac437d9cb733d7fc63bf7d.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#630503] text-white hover:bg-[#4a0402] font-semibold px-6 py-3 text-sm transition-colors rounded-lg inline-block"
                >
                  View Summer Reading PDF
                </a>
              </div>
            </div>

            {/* Back to School Fair */}
            <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden">
              <div className="bg-[#630503] p-6">
                <h3 className="text-2xl font-semibold text-white mb-2">Back to School Fair Flyers</h3>
              </div>
              <div className="p-8">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {/* English Version */}
                  <div>
                    <h4 className="text-lg font-medium text-gray-900 mb-3 text-center">English</h4>
                    <div
                      onClick={() => setSelectedImage({
                        src: "/assets/images/library/_Back to School Fair Flyer.png",
                        alt: "Back to School Fair Flyer - English"
                      })}
                      className="bg-gray-200 rounded-lg h-48 flex items-center justify-center cursor-pointer hover:shadow-lg transition-shadow duration-300"
                    >
                      <img 
                        src="/assets/images/library/_Back to School Fair Flyer.png" 
                        alt="Back to School Fair Flyer - English"
                        className="max-w-full max-h-full object-contain cursor-pointer"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'block';
                        }}
                      />
                      <div style={{display: 'none'}} className="text-center text-gray-600">
                        <div className="text-4xl mb-2">📚</div>
                        <p className="text-sm">Back to School Fair Flyer</p>
                        <p className="text-xs">Click to enlarge</p>
                      </div>
                    </div>
                  </div>

                  {/* Spanish Version */}
                  <div>
                    <h4 className="text-lg font-medium text-gray-900 mb-3 text-center">Español</h4>
                    <div
                      onClick={() => setSelectedImage({
                        src: "/assets/images/library/back to school fair flyer spanish.png",
                        alt: "Back to School Fair Flyer - Spanish"
                      })}
                      className="bg-gray-200 rounded-lg h-48 flex items-center justify-center cursor-pointer hover:shadow-lg transition-shadow duration-300"
                    >
                      <img 
                        src="/assets/images/library/back to school fair flyer spanish.png" 
                        alt="Back to School Fair Flyer - Spanish"
                        className="max-w-full max-h-full object-contain cursor-pointer"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'block';
                        }}
                      />
                      <div style={{display: 'none'}} className="text-center text-gray-600">
                        <div className="text-4xl mb-2">📚</div>
                        <p className="text-sm">Volante de Regreso a Clases</p>
                        <p className="text-xs">Haz clic para ampliar</p>
                      </div>
                    </div>
                  </div>
                </div>
                <p className="text-gray-600 leading-relaxed mt-6 text-center">
                  Click on any flyer to view it in full size
                </p>
              </div>
            </div>

            {/* Back to School */}
            <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden">
              <div className="bg-amber-600 p-6">
                <h3 className="text-2xl font-semibold text-white mb-2">Back to School Flyers</h3>
              </div>
              <div className="p-8">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {/* English Version */}
                  <div>
                    <h4 className="text-lg font-medium text-gray-900 mb-3 text-center">English</h4>
                    <div
                      onClick={() => setSelectedImage({
                        src: "/assets/images/library/back to school english.png",
                        alt: "Back to School Flyer - English"
                      })}
                      className="bg-gray-200 rounded-lg h-48 flex items-center justify-center cursor-pointer hover:shadow-lg transition-shadow duration-300"
                    >
                      <img 
                        src="/assets/images/library/back to school english.png" 
                        alt="Back to School Flyer - English"
                        className="max-w-full max-h-full object-contain cursor-pointer"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'block';
                        }}
                      />
                      <div style={{display: 'none'}} className="text-center text-gray-600">
                        <div className="text-4xl mb-2">🎒</div>
                        <p className="text-sm">Back to School Flyer</p>
                        <p className="text-xs">Click to enlarge</p>
                      </div>
                    </div>
                  </div>

                  {/* Spanish Version */}
                  <div>
                    <h4 className="text-lg font-medium text-gray-900 mb-3 text-center">Español</h4>
                    <div
                      onClick={() => setSelectedImage({
                        src: "/assets/images/library/back to school spanish.png",
                        alt: "Back to School Flyer - Spanish"
                      })}
                      className="bg-gray-200 rounded-lg h-48 flex items-center justify-center cursor-pointer hover:shadow-lg transition-shadow duration-300"
                    >
                      <img 
                        src="/assets/images/library/back to school spanish.png" 
                        alt="Back to School Flyer - Spanish"
                        className="max-w-full max-h-full object-contain cursor-pointer"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'block';
                        }}
                      />
                      <div style={{display: 'none'}} className="text-center text-gray-600">
                        <div className="text-4xl mb-2">🎒</div>
                        <p className="text-sm">Volante de Regreso a Clases</p>
                        <p className="text-xs">Haz clic para ampliar</p>
                      </div>
                    </div>
                  </div>
                </div>
                <p className="text-gray-600 leading-relaxed mt-6 text-center">
                  Click on any flyer to view it in full size
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Programs */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
              Library <span className="font-bold text-[#630503]">Events & Programs</span>
            </h2>
            <div className="w-24 h-px bg-[#630503]/40 mx-auto mb-8"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {/* Author Visits */}
            <div className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden">
              <div className="p-8">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">Author Visits</h3>
                <div className="bg-gray-200 rounded-lg h-64 flex items-center justify-center mb-6 overflow-hidden">
                  <img 
                    src="/assets/images/library/authorvisit.jpg" 
                    alt="Author Visit at P.S. 11X Library"
                    className="max-w-full max-h-full object-cover"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'block';
                    }}
                  />
                  <div style={{display: 'none'}} className="text-center text-gray-600">
                    <div className="text-4xl mb-2">✍️</div>
                    <p className="text-sm">Author Visit Photos</p>
                    <p className="text-xs">Author visit image</p>
                  </div>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  We regularly host published authors who share their work and writing process with our students, inspiring creativity and showing that anyone can be a writer.
                </p>
              </div>
            </div>

            {/* Scholastic Book Fair */}
            <div className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden">
              <div className="p-8">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">Scholastic Book Fair</h3>
                <div className="bg-gray-200 rounded-lg h-64 flex items-center justify-center mb-6 overflow-hidden">
                  <img 
                    src="/assets/images/library/bookfair.jpg" 
                    alt="Scholastic Book Fair at P.S. 11X"
                    className="max-w-full max-h-full object-cover"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'block';
                    }}
                  />
                  <div style={{display: 'none'}} className="text-center text-gray-600">
                    <div className="text-4xl mb-2">🎪</div>
                    <p className="text-sm">Book Fair Photos</p>
                    <p className="text-xs">Book fair image</p>
                  </div>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  Our annual Scholastic book fair brings the latest titles and student favorites directly to our school community, making reading accessible and exciting for all students.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Information */}
      <section className="py-20 bg-[#630503]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl lg:text-4xl font-light text-white mb-8">
              Visit Our <span className="font-bold">Library Spaces</span>
            </h2>
            <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed mb-12">
              Both library spaces are open during school hours. Our library team is here to help students discover their next favorite book.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-12">
              <div className="text-center">
                <h3 className="text-xl font-semibold text-white mb-4">Main Building Library</h3>
                <p className="text-white/80 mb-2">Grades 2-5</p>
                <p className="text-white/80">Breakfast - 7:30AM-8:00AM</p>
                <p className="text-white/80">8:00AM- 2:20PM</p>
              </div>
              <div className="text-center">
                <h3 className="text-xl font-semibold text-white mb-4">Satellite Building Library</h3>
                <p className="text-white/80 mb-2">Grades 3K-1</p>
                <p className="text-white/80">Breakfast - 7:30AM-8:00AM</p>
                <p className="text-white/80">8:00AM- 2:20PM</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-white text-[#630503] hover:bg-white/90 font-semibold px-8 py-4 text-base transition-colors rounded-lg">
                Contact Library Team
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80" onClick={() => setSelectedImage(null)}>
          <div className="relative w-full h-full max-w-7xl">
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-4 right-4 w-12 h-12 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center text-gray-600 hover:text-gray-800 hover:bg-white transition-all duration-200 z-10 shadow-lg"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <img
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="w-full h-full object-contain rounded-lg shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}

      <Footer />
    </main>
  );
};

export default Library; 